import React, { Component } from 'react';
import { connect } from 'react-redux';
import { navigate } from '../modules/high_level_actions';
import CategoryBar   from './CategoryBar.jsx';
import SortByBox   from './SortByBox.jsx';
import GiftShopCarousel from './GiftShopCarousel.jsx';
import CategoryItems  from './CategoryItems.jsx';

class GiftShop extends Component {

  constructor(props) {
    super(props);
  }

  onItemClick(target) {
    this.state = { activeNav: '' };
    let evt = {
      preventDefault: () => {},
      currentTarget: { pathname: target }
    }
    this.props.dispatch( navigate(evt) );
  }


  render() {
    let { activeFilterResult, activeFilter, giftGenres, urlParams } = this.props;

    if ( urlParams && urlParams.length === 2 ){
      // add sort in
      let genreIndex = giftGenres.findIndex( x => x.id === activeFilterResult.id) + 1;
      return (
        <div className="gift-genre">
          <div className="mobileSort">
            <SortByBox
              currentCategory = {this.props.activeFilterResult.name} />
          </div>
          <div className="gift-header">
            <div className="gift-shop-logo" onClick={() => this.onItemClick( '/catalog/giftshop')}/>
            <div className={"gift-shop-header header" + genreIndex} />
          </div>
          <div className="desktopSort">
            <SortByBox
              currentCategory = {this.props.activeFilterResult.name} />
          </div>
          <CategoryItems
            products                = {this.props.sortedProducts} />
        </div>
      );
    } else {
      let aGenre = giftGenres.map((oGenre, i) => {
      return (
        <div key={oGenre.id}
             className={"genre genre" + (i + 1) }
             onClick={() => this.onItemClick( '/catalog/giftshop/' + oGenre.id + '-' + oGenre.url )} />
        );
      });

      return (
        <div className="gift-shop ">
          <div className="gift-shop-logo" />
          { aGenre }
          <div className="bottom-banner-container">
            <hr />
            <div className="bottom-banner" />
            <hr />
          </div>
          <GiftShopCarousel />
        </div>
      );
    }
  }
};

GiftShop.defaultProps = {
  activeFilter: '',
  activeFilterResult: {
    products: []
  }
};


function mapStateToProps(state){
    return {
      'giftGenres': state.store.giftShop.filter((x,i) => i !== 0 ).map( x => state.maps.get("genreMap").get(x) ),
      'activeFilterResult': state.activeFilterResult,// first genre
      'sortedProducts': state.sort.products,
      'activeFilter': state.activeFilter,
      'urlParams' : state.urlParams
    };
}

export default connect(mapStateToProps)(GiftShop);



// WEBPACK FOOTER //
// ./src/components/GiftShop.jsx